import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

export default class OnlineConsultationReportWrittenJournalEvent extends JournalEvent {
  static override type = "online-consultation-report-written-journal-event";

  @attr("string") declare body: string;

  static override validations(intl: IntlService) {
    return {
      body: validatePresence({
        presence: true,
        description: intl.t(
          "validations.online-consultation-report-written-journal-event.body"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.online-consultation-report-written-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "onlineConsultationReportWrittenJournalEvents"
  })
  declare patient: Patient;

  override get summary() {
    return Object.assign({}, super.summary, {
      forcIdentifier: {
        feature: "online-consultation",
        component: "report-edition-form"
      }
    });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "online-consultation-report-written-journal-event": OnlineConsultationReportWrittenJournalEvent;
  }
}
